import { FunctionComponent } from "react";
import classNames from "classnames";
import { ReactComponent as TooltipIcon } from "../../../asset/images/tooltip.svg";
import styles from "./Tab.module.scss";

export interface TabProps {
  text: string;
  icon: React.ReactElement;
  tooltipText?: string;
  active?: boolean;
  index?: number;
  onClick?: any;
}

const Tab: FunctionComponent<TabProps> = ({
  text,
  icon,
  tooltipText,
  active = false,
  index,
  onClick,
}) => {
  return (
    <div
      className={classNames(styles["tab"], active === true && styles["active"])}
      onClick={() => onClick(index)}
    >
      <div className={classNames(styles["tab__icon"])}>{icon}</div>
      <div className={classNames(styles["tab__text"])}>
        <div className="text text--body-2 text--bold">{text}</div>
      </div>
      {tooltipText && (
        <div className={classNames(styles["tab__tooltip"])}>
          <TooltipIcon />
        </div>
      )}
    </div>
  );
};

export default Tab;
